import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
export default function BillingProducts() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [productCategory, setProductCategory] = useState([]);
    const [open, setOpen] = useState(false);
    const [category, setCategory] = useState("");
    const [productName, setProductName] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [editState, setEditState] = useState(null);
    useEffect(() => {
        fetchProductData();
    }, []);
    const fetchProductData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "billing-products";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "productcategory";
            const response = await makeRequest("get", url);
            if (response) {
                setProductCategory(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAdd = () => {
        setEditState(null);
        setCategory("");
        setProductName("");
        setOpen(true);
    };
    const openEdit = (data) => {
        setEditState(data);
        setCategory(data?.product_category_id);
        setProductName(data?.product_name);
        setOpen(true);
    };
    const handleSave = async () => {
        if (!productName || !category) {
            setMessage("All Fileds are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const categoryEditData = {
                    product_category_id: category,
                    product_name: productName
                };
                try {
                    let url = webEndPoint + "billing-products/" + editState.rfId;
                    const response = await makeRequest("put", url, categoryEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Product Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const categoryAddData = {
                    product_category_id: category,
                    product_name: productName
                };
                try {
                    let url = webEndPoint + "billing-products";
                    const response = await makeRequest("post", url, categoryAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Product Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            setDataSource([]);
            fetchProductData();
            setSnackbar(true);
            setOpen(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const columns = ["S.No", "Category", "Bill Product Name", "Action"];
    const rows = dataSource?.map((p, i) => {
        return [i + 1, p.category_name, p.product_name,
        <Box>
            <Tooltip title="Edit">
                <IconButton onClick={() => openEdit(p)} color="primary">
                    <EditIcon />
                </IconButton>
            </Tooltip>
        </Box>
        ];
    });
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Billing Products</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Add Billing Product</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box component="div" sx={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 800 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{editState !== null ? "Edit Billing Product" : "Add Billing Product"}</Typography>
                        <TextField select label="Select Product Category" value={category} onChange={(e) => setCategory(e.target.value)} sx={{ mb: 2 }} fullWidth>
                            {productCategory.map((cat) => (
                                <MenuItem key={cat.rfId} value={cat.rfId}>{cat.category_name}</MenuItem>
                            ))}
                        </TextField>
                        <TextField label="Billing Product Name" fullWidth value={productName} onChange={(e) => setProductName(e.target.value)} sx={{ mb: 2 }} />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}